module.exports = __webpack_public_path__ + "img/rating-page-slider-mobile-6.9c5b05ba.png";